module.exports = __webpack_public_path__ + "img/03-bucheck.7b85817f.jpg";